import { renderToggleButton_unstable } from '@fluentui/react-button';

/**
 * Renders the final JSX of the ToolbarRadioButton component, given the state.
 */
export const renderToolbarRadioButton = renderToggleButton_unstable;
